module.exports = __webpack_public_path__ + "media/shenghuoquan.ecc44373.mp4";